// extracted by mini-css-extract-plugin
module.exports = {"container":"ConditionLabel_container__n5ro1","icon":"ConditionLabel_icon__3ikTl","passed":"ConditionLabel_passed__WZbk8","text":"ConditionLabel_text__QH16S"};